export default __webpack_public_path__ + "static/media/users_icon.2695b8ad.svg";